import React, { useState, useCallback } from 'react';
import {
  TagEditorContainer,
  Tag,
  TagText,
  TagRemoveButton,
  AddTagButton,
  TagInput
} from './TagEditor.styled';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';

/**
 * Tag Editor Component
 * Allows adding and removing tags from documents
 */
const TagEditor = ({ tags = [], onAddTag, onRemoveTag }) => {
  const [isAdding, setIsAdding] = useState(false);
  const [newTag, setNewTag] = useState('');

  const handleAddClick = useCallback(() => {
    setIsAdding(true);
  }, []);

  const handleAddTag = useCallback(() => {
    const trimmedTag = newTag.trim().toLowerCase();
    
    if (trimmedTag && !tags.includes(trimmedTag)) {
      onAddTag?.(trimmedTag);
    }
    
    setNewTag('');
    setIsAdding(false);
  }, [newTag, tags, onAddTag]);

  const handleKeyDown = useCallback((e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleAddTag();
    } else if (e.key === 'Escape') {
      setNewTag('');
      setIsAdding(false);
    }
  }, [handleAddTag]);

  const handleRemoveTag = useCallback((tag) => {
    onRemoveTag?.(tag);
  }, [onRemoveTag]);

  return (
    <TagEditorContainer>
      {tags.map((tag) => (
        <Tag key={tag}>
          <TagText>{tag}</TagText>
          <TagRemoveButton onClick={() => handleRemoveTag(tag)}>
            <CloseIcon style={{ fontSize: '14px' }} />
          </TagRemoveButton>
        </Tag>
      ))}
      
      {isAdding ? (
        <TagInput
          value={newTag}
          onChange={(e) => setNewTag(e.target.value)}
          onBlur={handleAddTag}
          onKeyDown={handleKeyDown}
          placeholder="Add tag..."
          autoFocus
        />
      ) : (
        <AddTagButton onClick={handleAddClick}>
          <AddIcon style={{ fontSize: '14px' }} />
          <span>Add tag</span>
        </AddTagButton>
      )}
    </TagEditorContainer>
  );
};

export default TagEditor;

